<template>
  <v-dialog v-model="open" persistent :max-width="maxWidth" width="auto">
    <v-card class="d-flex flex-column">
      <v-card-text class="px-8 pt-6">
        <slot v-bind="{ message }">
          <p class="text-h6 font-weight-regular">{{ message }}</p>
        </slot>
      </v-card-text>
      <v-card-actions class="justify-end px-8 pb-6">
        <v-btn color="primary" text dense @click="close"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NotificationDialog',
  props: {
    maxWidth: {
      type: [Number, String],
      default: '80%',
    },
  },
  data() {
    return {
      open: false,
      message: '',
    }
  },
  methods: {
    show(message) {
      this.open = true
      this.message = message
    },
    close() {
      this.open = false
      this.message = ''
    },
  },
}
</script>

<style scoped></style>
